import { 
  ComplexityScore, 
  MeasureReportCustom, 
  PatientCustom, 
  QuestionnaireResponseCustom, 
  RequestCustom, 
  RequesterCustom 
} from 'src/careflow/inck/nat-task/report/report-type';
import { apiClient } from 'src/careflow/ph-core/api_client/api_client';
import { urlBackNestApp } from 'src/routes/urls';

export interface ResendReprocessResponse {
  status: string;
}

export interface TaskCustom {
  patient: PatientCustom;
  request: RequestCustom;
  requester: RequesterCustom;
  medical_complexity: ComplexityScore;
  social_complexity: ComplexityScore;
  service_integration_levels: ComplexityScore;
  measure_report: MeasureReportCustom[];
  questionnaire_response_list: QuestionnaireResponseCustom[];
}

const apiBase = 'nat/task';

const TaskApi = {

  resendTask: async (taskId: string) => {
    return apiClient.get<ResendReprocessResponse | undefined>(
      `${apiBase}/${taskId}/resend`
    );
  },

  reprocessMeasureReport: async (measureReportId: string) => {
    return apiClient.get<ResendReprocessResponse | undefined>(
      `${apiBase}/${measureReportId}/reprocess`
    );
  },

  getPrintable: async (body: Partial<TaskCustom>) => {
    return apiClient.post<any, any>(
      `${urlBackNestApp}/nat/task/printable`,
      body,
      { headers: { responseType: "arraybuffer", timeout: '20000' } }
    );
  },

  createTask: async (payload: any) => {
    return apiClient.post<any, undefined>(
      `${apiBase}/`, payload
    );
  },

  getQuestionnaireAnswerMap: async (questionaireIds: string[]) => {
    return apiClient.get<any>(
      `${urlBackNestApp}/nat/task/questionnaire-answer-map/${questionaireIds}`
    );
  }
}

export const TaskService = {

  resendTask: async (taskId: string): Promise<ResendReprocessResponse | undefined> => {
    const response = await TaskApi.resendTask(taskId);
    if (!response) return undefined;
    return response;
  },

  reprocessMeasureReport: async (measureReportId: string): Promise<ResendReprocessResponse | undefined> => {
    const response = await TaskApi.reprocessMeasureReport(measureReportId);
    if (!response) return undefined;
    return response;
  },

  getPrintable: async (body: Partial<TaskCustom>) => {
    const response = await TaskApi.getPrintable(body);
    if (!response) return undefined;
    return response;
  },

  createTask: async (payload: any) => {
    const response = await TaskApi.createTask(payload);
    if (!response) return undefined;
    return response;
  },

  getQuestionnaireAnswerMap: async (questionaireIds: string[]) => {
    const response = await TaskApi.getQuestionnaireAnswerMap(questionaireIds);
    if (!response) return undefined;
    return response;
  }
}
